(() => {
 'use strict';
 function initialise(scope = document) {
  scope.querySelectorAll('[data-dt-root]').forEach(root => {
   if (root.dataset.dtInitialised) return;
   const source = root.querySelector('[data-dt-variants]');
   let variants;
   try { variants = JSON.parse(source?.textContent || '[]'); } catch { return; }
   const full = root.querySelector('[data-dt-variant]');
   const controls = [...root.querySelectorAll('[data-dt-option]')];
   if (!variants.length || !full || controls.length !== 3) return;
   root.dataset.dtInitialised = 'true';
   const purchase = root.dataset.dtPurchase === 'true';
   const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
   function paint(variant, updateUrl = false) {
    if (!variant) return;
    full.value = String(variant.id);
    controls.forEach((control, i) => {
     const prefix = variant.options.slice(0, i);
     const valid = new Set(variants.filter(v => prefix.every((x,j) => v.options[j] === x)).map(v => v.options[i]));
     [...control.options].forEach(o => { o.disabled = !valid.has(o.value); });
     control.value = variant.options[i];
    });
    const price = root.querySelector('[data-dt-price]');
    if (price) price.textContent = variant.price;
    root.querySelector('[data-dt-sku]').textContent = variant.sku;
    const add = root.querySelector('[data-dt-add]');
    if (add) { add.disabled = !purchase || !variant.available; add.textContent = variant.available ? 'Add to cart' : 'Currently unavailable'; }
    root.querySelector('[data-dt-selection-note]').textContent = variant.options[1] === 'Unperforated' ? 'Unperforated: no preset outlets. The illustrations show outlet versions.' : 'One roll in the configuration selected above.';
    const quote = new URL(root.dataset.dtQuote, document.baseURI);
    quote.searchParams.set('product', root.dataset.dtProduct);
    quote.searchParams.set('sku', variant.sku);
    quote.searchParams.set('variant', variant.title);
    quote.searchParams.set('page', location.href);
    root.querySelectorAll('[data-dt-quote-link]').forEach(a => { a.href = quote.href; });
    const wa = new URL('https://wa.me/8615951241570');
    wa.searchParams.set('text', `Hello FARM GUARD, please quote: ${root.dataset.dtProduct} | ${variant.title} | SKU: ${variant.sku} | Rolls: | Destination: | ${location.href}`);
    const waLink = root.querySelector('[data-dt-whatsapp]');
    if (waLink) waLink.href = wa.href;
    if (updateUrl) { const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url.href); }
   }
   controls.forEach((control,index) => control.addEventListener('change', () => {
    const wanted = controls.map(c => c.value);
    const matches = variants.filter(v => wanted.slice(0,index+1).every((x,i) => v.options[i] === x));
    const exact = matches.find(v => wanted.every((x,i) => v.options[i] === x));
    paint(exact || matches[0], true);
   }));
   full.addEventListener('change', () => paint(variants.find(v => String(v.id) === full.value), true));
   root.querySelectorAll('[data-dt-select]').forEach(link => link.addEventListener('click', event => {
    const v = variants.find(v => String(v.id) === link.dataset.dtSelect);
    if (!v) return;
    event.preventDefault(); paint(v,true);
    root.querySelector('.dt-buy').scrollIntoView({behavior:reduced()?'auto':'smooth',block:'start'});
    controls[0].focus({preventScroll:true});
   }));
   let imageCounter = 0;
   root.querySelectorAll('[data-dt-image]').forEach(link => link.addEventListener('click', event => {
    const image = root.querySelector('.dt-main-image');
    if (!image) return;
    event.preventDefault(); const sequence=++imageCounter;
    image.removeAttribute('srcset'); image.removeAttribute('sizes');
    image.src = link.dataset.dtImage; image.alt = link.dataset.dtAlt || '';
    root.querySelectorAll('[data-dt-image]').forEach(a => a.setAttribute('aria-current',String(a===link)));
    const animate = () => { if(sequence===imageCounter && !reduced() && typeof image.animate==='function') { image.getAnimations().forEach(a=>a.cancel()); image.animate([{opacity:.45,transform:'scale(1.01)'},{opacity:1,transform:'scale(1)'}],{duration:200,easing:'ease-out'}); } };
    if (typeof image.decode === 'function') image.decode().then(animate).catch(()=>{}); else animate();
   }));
   const form = root.querySelector('.dt-form');
   form.addEventListener('submit', event => { const v = variants.find(v=>String(v.id)===full.value); if(!purchase || !v?.available) event.preventDefault(); });
   paint(variants.find(v=>String(v.id)===full.value) || variants[0]);
   root.querySelector('[data-dt-selectors]').hidden=false;
   root.querySelector('.dt-complete').hidden=true;
  });
 }
 if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>initialise()); else initialise();
 document.addEventListener('shopify:section:load',event=>initialise(event.target));
})();
